import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { renderItemSinglePath } from "../../Common/Function";
import { GetItem } from "./Components/Services";

const Redirect = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const initialState = {
    loading: true,
    favorite_status: null,
    sans_loading: true,
    data: {
      data: null,
      current_page: null,
    },
  };
  const [state, setState] = useState(initialState);
  useEffect(() => {
    Handler();
  }, []);
  const Handler = () => {
    setState({ ...state, loading: true });
    GetItem(slug).then(result => {
      if (result) {
        navigate(
          renderItemSinglePath(
            result.Items.category_id,
            result.Items.city[0].slug,
            result.Items.slug
          )
        );
      } else {
        // navigate(-1);
      }
    });
  };
  return <div></div>;
};

export default Redirect;
// /pool/shahrud/استخر-موج-شاهرود
